import makeSafeOperation from './makeSafeOperation';
import getSubscribeOnce from './subscribeOnce';
import promisify from './promisify';

function getClient(_ref) {
  var messageBus = _ref.messageBus,
      readyTopic = _ref.readyTopic,
      operationSelector = _ref.operationSelector;
  var operationAvailable = promisify(getSubscribeOnce({
    messageBus: messageBus
  }))(readyTopic);
  var operations = {
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    UNSUBSCRIBE_ALL: 'unsubscribeAll'
  };

  var getSubscribeOperation = function getSubscribeOperation() {
    return operationSelector(operations.SUBSCRIBE);
  };

  var getUnsubscribeOperation = function getUnsubscribeOperation() {
    return operationSelector(operations.UNSUBSCRIBE);
  };

  var getUnsubscribeAllOperation = function getUnsubscribeAllOperation() {
    return operationSelector(operations.UNSUBSCRIBE_ALL);
  };

  var safeSubscribe = makeSafeOperation({
    getOperation: getSubscribeOperation,
    operationAvailable: operationAvailable
  });
  var safeUnsubscribe = makeSafeOperation({
    getOperation: getUnsubscribeOperation,
    operationAvailable: operationAvailable
  });
  var safeUnsubscribeAll = makeSafeOperation({
    getOperation: getUnsubscribeAllOperation,
    operationAvailable: operationAvailable
  });
  return {
    subscribe: function subscribe(payload) {
      safeSubscribe(payload);
    },
    unsubscribe: function unsubscribe(payload) {
      safeUnsubscribe(payload);
    },
    unsubscribeAll: function unsubscribeAll(payload) {
      safeUnsubscribeAll(payload);
    }
  };
}

export default getClient;